const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.login.token,
  userInfo: state => state.login.userInfo,
  roles: state => state.login.roles,
  banks: state => state.login.banks,
  menus: state => state.login.menus,
  userTypes: state => state.login.userTypes,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js